<script>
export default {
  name: 'FAQQuestion',
  props: ['question', 'number', 'answer']
}
</script>

<template>
  <v-expansion-panel class="panel">
    <v-expansion-panel-header class="header">
      <template v-slot:default="{ open }">
        <div>
          <v-icon v-if="!open" large color="primary">mdi-plus</v-icon>
          <v-icon v-else large color="primary">mdi-minus</v-icon>
          <div v-html="question" class="question"></div>
        </div>
      </template>
      <template v-slot:actions>
        <v-icon></v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content v-html="answer" class="content text-left answer"></v-expansion-panel-content>
  </v-expansion-panel>
</template>

<style lang="scss" scoped>

.header {
  color: $hpp-blue;
  font-weight: 500;
  font-size: 24px;
}
.question {
  position: relative;
  left: 50px;
  top: -30px;
}
.content {
  font-size: 13px;
  color: $hpp-greytext;
}
.panel {
  background-color: rgba(0, 0, 0, 0) !important;
}
.answer {
  margin-left: 53px;
  font-size: 14px;
}

@media only screen and (max-width: 960px) {
  .header {
    font-size: 20px;
    margin-bottom: 8px;
  }
  .question {
    left: 40px;
    top: -28px;
  }
  .answer {
    margin-left: 0;
  }
}

</style>
